module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-5-f27c687d8da4caeb86075be676d78ec4.jpg";